<p-toast></p-toast>

<form [formGroup]="vendorForm" (ngSubmit)="vendorSubmit()">
  <p-stepper orientation="vertical" #addVendorStepper [linear]="true">

    <!-- STEP 1 -->
    <p-stepperPanel header="Vendor Info">
      <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
        <p-card>
          <div class="formgrid grid">
            <input type="hidden" formControlName="vendorInfo_CampaignId" />

            <div class="field col-12 md:col-4">
              <label for="vendorTypeId" class="field-label required">Vendor Type</label>
              <p-dropdown id="vendorTypeId" [options]="vendorTypes" optionLabel="value" optionValue="key"
                placeholder="Please Select" formControlName="vendorTypeId"></p-dropdown>
              <small *ngIf="vendorForm.get('vendorTypeId')?.invalid && vendorForm.get('vendorTypeId')?.touched"
                class="error">
                Vendor Type is required.
              </small>
            </div>
            <!-- Show First/Last Name if IND or CAD -->
            <div *ngIf="isIndividualType" class="field col-12 md:col-4">
              <label for="firstName" class="field-label required">First Name</label>
              <input id="firstName" pInputText formControlName="firstName" autocomplete="off" maxlength="65" />
              <small *ngIf="vendorForm.get('firstName')?.invalid && vendorForm.get('firstName')?.touched" class="error">
                FirstName is required.
              </small>
            </div>

            <div *ngIf="isIndividualType" class="field col-12 md:col-4">
              <label for="lastName" class="field-label required">Last Name</label>
              <input id="lastName" pInputText formControlName="lastName" autocomplete="off" maxlength="65" />
              <small *ngIf="vendorForm.get('lastName')?.invalid && vendorForm.get('lastName')?.touched" class="error">
                LastName is required.
              </small>
            </div>

            <!-- Show Organization if ORG, CCM, COM, PAC, PTY -->
            <div *ngIf="isOrganizationType" class="field col-12 md:col-4">
              <label for="organizationName" class="field-label required">Organization</label>
              <input id="organizationName" pInputText formControlName="organizationName" autocomplete="off"
                maxlength="65" />
              <small *ngIf="vendorForm.get('organizationName')?.invalid && vendorForm.get('organizationName')?.touched"
                class="error">
                Organization is required.
              </small>
            </div>
            <div class="col-12"></div>

            <div class="field col-12 md:col-4">
              <label for="vendorInfo_TaxId">Tax ID Number</label>
              <input id="vendorInfo_TaxId" pInputText formControlName="vendorInfo_TaxId" autocomplete="off"
                maxlength="15" />
            </div>

            <div class="field col-12 md:col-4">
              <label for="vendorInfo_1099Id" class="field-label required">Tax Type</label>
              <p-dropdown [options]="vendor1099Types" formControlName="vendorInfo_1099Id" optionLabel="text"
                optionValue="value" placeholder="Please Select"></p-dropdown>
              <small
                *ngIf="vendorForm.get('vendorInfo_1099Id')?.invalid && vendorForm.get('vendorInfo_1099Id')?.touched"
                class="error">
                TaxType is required.
              </small>
            </div>

            <div class="field col-12">
              <label for="w9Forms">Attach W9 Form</label>
              <p-fileUpload #fileUploader multiple="true" [auto]="false" [showUploadButton]="mode === 'add' ? false: true"
                customUpload="true" accept=".doc,.docx,.pdf,.csv,.xls,.xlsx,.png,.jpg,.jpeg,.eml,.msg"
                [maxFileSize]="5000000" chooseLabel="Select" (onSelect)="onFileChange($event)"
                (uploadHandler)="onFileUpload($event)"></p-fileUpload>
            </div>

            <div class="field col-12" *ngIf="attachments.length>0">
              <h4>Current W9's</h4>
              <p-table [value]="attachments" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Number</th>
                    <th>File Name</th>
                    <th>Actions</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-attachment>
                  <tr>
                    <td>{{ attachment.attachmentId }}</td>
                    <td><a href="#" (click)="onDownloadW9(attachment, $event)"><strong>{{ attachment.fileName
                          }}</strong></a></td>
                    <td>
                      <rc-generic-button 
                        (click)="deleteAttachment(attachment)" label="Delete" iconImg="trash" iconColor="red-light" [isIconOnly]="true" data-cy="btn-Delete" [classes]="['table-action-btn']" />
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-card>
        <p-card>
          <div class="formgrid grid">
            <div class="field col-12 md:col-6">
              <label for="vendorInfo_DefaultPaymentMethodId">Default Payment Method</label>
              <p-dropdown [options]="paymentTypes" formControlName="vendorInfo_DefaultPaymentMethodId"
                optionLabel="value" optionValue="key" placeholder="Please Select"></p-dropdown>
            </div>

            <div class="field col-12 md:col-6">
              <label for="vendorInfo_DefaultFECLineNumber">Default Line Number</label>
              <p-dropdown [options]="complianceTypes" formControlName="vendorInfo_DefaultFECLineNumber"
                optionLabel="text" optionValue="value" placeholder="Please Select"></p-dropdown>
            </div>

            <div class="field col-12 md:col-6">
              <label for="vendorInfo_DefaultFECDescription">Default FEC Description</label>
              <input id="vendorInfo_DefaultFECDescription" pInputText formControlName="vendorInfo_DefaultFECDescription"
                autocomplete="off" maxlength="255" />
            </div>

            <div class="field col-12 md:col-6">
              <label for="glnewAccount">Default GL Account</label>
              <p-autoComplete id="glnewAccount" formControlName="glnewAccount" [suggestions]="accountSuggestions"
                (completeMethod)="searchAccount($event.query)" (onSelect)="onAccountSelect($event)"
                placeholder="Type to Search"></p-autoComplete>
            </div>
          </div>
        </p-card>
        <p-card>
          <p-button label="Next" id="usersNextButton" (click)="nextStep1()" severity="secondary" />
        </p-card>
      </ng-template>
    </p-stepperPanel>

    <!-- STEP 2 -->
    <p-stepperPanel header="Contact Person">
      <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback"
        let-index="index">
        <p-card>
          <div class="formgrid grid">
            <div class="field col-12 md:col-4">
              <label for="vendorInfo_ContactName">Contact Name</label>
              <input id="vendorInfo_ContactName" pInputText formControlName="vendorInfo_ContactName" maxlength="61" />
            </div>

            <div class="field col-12 md:col-4">
              <label for="vendorInfo_Phone">Phone</label>
              <p-inputMask id="vendorInfo_Phone" formControlName="vendorInfo_Phone" mask="(999)999-9999" maxlength="14"
                placeholder=""></p-inputMask>
            </div>

            <div class="field col-12 md:col-4">
              <label for="vendorInfo_Email">Email</label>
              <input id="vendorInfo_Email" pInputText formControlName="vendorInfo_Email" maxlength="201" />
              <small
                *ngIf="vendorForm.get('vendorInfo_Email')?.touched && vendorForm.get('vendorInfo_Email')?.errors?.['email']"
                class="error">Please enter a valid email.</small>
            </div>

            <div class="field col-12 md:col-4">
              <label for="vendorInfo_AddressLine1" class="field-label required">Address 1</label>
              <input id="vendorInfo_AddressLine1" pInputText formControlName="vendorInfo_AddressLine1" maxlength="61" />
              <small
                *ngIf="vendorForm.get('vendorInfo_AddressLine1')?.invalid && vendorForm.get('vendorInfo_AddressLine1')?.touched"
                class="error">
                Address1 is required.
              </small>
            </div>

            <div class="field col-12 md:col-4">
              <label for="vendorInfo_AddressLine2">Address 2</label>
              <input id="vendorInfo_AddressLine2" pInputText formControlName="vendorInfo_AddressLine2" maxlength="61" />
            </div>

            <div class="field col-12 md:col-4">
              <label for="vendorInfo_City" class="field-label required">City</label>
              <input id="vendorInfo_City" pInputText formControlName="vendorInfo_City" maxlength="35" />
              <small *ngIf="vendorForm.get('vendorInfo_City')?.invalid && vendorForm.get('vendorInfo_City')?.touched"
                class="error">
                City is required.
              </small>
            </div>

            <div class="field col-6 md:col-4">
              <label for="vendorInfo_State" class="field-label required">State</label>
              <p-dropdown [options]="states" formControlName="vendorInfo_State" placeholder="Please Select"
                optionLabel="text" optionValue="value"></p-dropdown>
              <small *ngIf="vendorForm.get('vendorInfo_State')?.invalid && vendorForm.get('vendorInfo_State')?.touched"
                class="error">
                State is required.
              </small>
            </div>

            <div class="field col-6 md:col-4">
              <label for="vendorInfo_Zip" class="field-label required">Zip Code</label>
              <input id="vendorInfo_Zip" pInputText formControlName="vendorInfo_Zip" maxlength="10"
                placeholder="" />
              <small *ngIf="vendorForm.get('vendorInfo_Zip')?.invalid && vendorForm.get('vendorInfo_Zip')?.touched"
                class="error">
                Zip Code is required.
              </small>
            </div>
          </div>
        </p-card>

        <p-card>
          <p-button label="Previous" [outlined]="true" severity="secondary" (click)="prevStep1()" />
          <p-button label="Next" (click)="nextStep2()" severity="secondary" />
        </p-card>
      </ng-template>
    </p-stepperPanel>

    <!-- STEP 4 -->
    <p-stepperPanel header="Default Approvers">
      <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback"
        let-index="index">
        <p-card styleClass="pt-3">
          <div class="formgrid grid">
            <div class="field col-12 lg:col-6">
              <div class="flex align-items-center">
                  <p-toggleButton   
                    inputId="vendorInfo_Default_NoApprovalRequired"
                    formControlName="vendorInfo_Default_NoApprovalRequired" onLabel="Yes" 
                    offLabel="No"
                    [onIcon]="onIcon"
                    offIcon="pi pi-ban"
                    (onChange)="toggleInternalExpense($event)"></p-toggleButton>
                  <span class="ml-3"><b>Internal Expense</b> <span class="flex flex-nowrap">(No Client Approval Required)</span></span>
              </div>

              <div *ngIf="!internalExpense" class="field mt-5">
                <label class="field-label" for="approver">Add New Approver</label>
                <p-autoComplete 
                  id="approver" 
                  formControlName="approver"
                  [suggestions]="approverSuggestions" 
                  (completeMethod)="searchApprover($event.query)"
                  (onSelect)="onApproverSelect($event)" 
                  placeholder="Type Approver Name"></p-autoComplete>
              </div>
            </div>

            <div *ngIf="approvers.length>0" class="field col-12 xl:col-6">
              <div>
                <h4>Assigned Approvers</h4>
                <p-table [value]="approvers" responsiveLayout="scroll" styleClass="approvers-table">
                  <ng-template pTemplate="body" let-approver>
                    <tr>
                      <td><strong>{{ approver.name }}</strong></td>
                      <td>
                        <rc-generic-button 
                          label="Delete"
                          iconImg="trash"
                          iconColor="red-light"
                          [isIconOnly]="true"
                          (click)="deleteApprover(approver)" />
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </p-card>
        <p-card>
          <p-button label="Previous" [outlined]="true" severity="secondary"
            (click)="prevStep2()" />
          <p-button label="Next" (click)="nextStep3()" severity="secondary" />
        </p-card>
      </ng-template>
    </p-stepperPanel>

    <p-stepperPanel header="Remit Address">
      <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback"
        let-index="index">
        <p-card>
          <div class="formgrid grid">
            <div class="field col-12 md:col-4">
              <label for="vendorInfo_VendorCheckName" class="field-label required">Vendor Check Name</label>
              <input id="vendorInfo_VendorCheckName" pInputText formControlName="vendorInfo_VendorCheckName"
                maxlength="130" />
              <small
                *ngIf="vendorForm.get('vendorInfo_VendorCheckName')?.invalid && vendorForm.get('vendorInfo_VendorCheckName')?.touched"
                class="error">
                Address1 is required.
              </small>
            </div>

            <div class="field col-12"></div>

            <div class="field col-12 md:col-4">
              <label for="vendorInfo_RemitToAddressLine1">Address 1</label>
              <input id="vendorInfo_RemitToAddressLine1" pInputText formControlName="vendorInfo_RemitToAddressLine1"
                maxlength="61" />
            </div>

            <div class="field col-12 md:col-4">
              <label for="vendorInfo_RemitToAddressLine2">Address 2</label>
              <input id="vendorInfo_RemitToAddressLine2" pInputText formControlName="vendorInfo_RemitToAddressLine2"
                maxlength="61" />
            </div>

            <div class="field col-12 md:col-4">
              <label for="vendorInfo_RemitToCity">City</label>
              <input id="vendorInfo_RemitToCity" pInputText formControlName="vendorInfo_RemitToCity" maxlength="35" />
            </div>

            <div class="field col-6 md:col-4">
              <label for="vendorInfo_RemitToState">State</label>
              <p-dropdown [options]="states" formControlName="vendorInfo_RemitToState" placeholder="Please Select"
                optionLabel="text" optionValue="value"></p-dropdown>
            </div>

            <div class="field col-6 md:col-4">
              <label for="vendorInfo_RemitToZip">Zip Code</label>
              <input id="vendorInfo_RemitToZip" pInputText formControlName="vendorInfo_RemitToZip" maxlength="10"
                placeholder="" maxlength="10" />
            </div>
          </div>
        </p-card>
        <p-card>
          <p-button label="Previous" [outlined]="true" severity="secondary"
            (click)="prevStep3()" />
        </p-card>
      </ng-template>
    </p-stepperPanel>
  </p-stepper>

  <div class="imported-dialog-footer">
    <!-- (onClick)="onCancel()" -->
    <p-button label="Cancel" type="button" [text]="true" (onClick)="closeVendor()"></p-button>
    <button pButton label="Save" class="ml-1" [disabled]="vendorForm.invalid"></button>
  </div>
</form>

<!-- Confirmation Dialog -->
<p-dialog header="Confirm Action" 
  [(visible)]="dialogVisible" 
  [modal]="true" 
  [closable]="false"
  styleClass="p-confirm-dialog">

  <p>{{ dialogMessage }}</p>
  
  <ng-template pTemplate="footer">
    <button pButton label="No" (click)="onDialogReject()" class="p-button-outlined"></button>
    <button pButton label="Yes" (click)="onDialogAccept()"></button>
  </ng-template>
</p-dialog>